import { Injectable } from '@angular/core';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { filter, map } from 'rxjs/operators';

// Serviço utilizado para verificar permissoes de acesso do usuario logado
@Injectable({
    providedIn: 'root'
  })
export class PermissaoService {
    constructor(private usuarioService: BnUsuarioService) {
    }

    //FIXME não precisa mais do parâmetro, mudar nome do método também
    getPermissoesUsuarioAutenticado(): any {
        return this.usuarioService.usuario$.pipe(
            filter(usuario => usuario != null),
            map(usuario => usuario.permissoes));
  }
}